import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Plot } from './models/plot.model';
import { ApiService } from '../../shared/services/api.service';
import { API_BASE_URL } from '../../shared/tokens/api.tokens';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class PlotsService extends ApiService<Plot> {

  readonly _baseUrl: string;

  readonly searchFields = ['plotNumber'];

  constructor(@Inject(API_BASE_URL) apiBaseUrl: string, http: HttpClient, errorHandler: ErrorHandlerService) { 
    super(http, errorHandler);
    this._baseUrl = `${apiBaseUrl}plots/`;    
  }  

}
